module.exports = __webpack_public_path__ + "static/media/loacode_signin_text.09869625.svg";